/**
 * Cuenta bancaria
 *
 */
import React from 'react'
import Api from '../../../Api'
import Exception from '../../../Exception'
import { Form, Select, Modal, Button, Row, Col, Input, Popconfirm } from 'antd'

function buildFormObject(values = {}) {
  return {
    iId: values.iId,
    sNombreCorto: values.sNombreCorto || null,
    sRazonSocial: values.sRazonSocial || null,
    sRfc: values.sRfc || null,
    sEmail: values.sEmail || null,
    sDomicilio: values.sDomicilio || null,
    sColonia: values.sColonia || null,
    sCiudad: values.sCiudad || null,
    sCP: values.sCP || null,
    sTelefono: values.sTelefono || null,
    sExt: values.sExt || null,
    sRepresentante: values.sRepresentante || null,
    iTipoContrib: values.iTipoContrib === null || values.iTipoContrib === undefined ? true : values.iTipoContrib,
    iProvNacional: values.iProvNacional === null || values.iProvNacional === undefined ? true : values.iProvNacional,
  }
}

class InformacionForm extends React.Component {
  /**
   * handleSubmit
   *
   */
  handleSubmit = (e) => {
    this.props.form.validateFields((err, values) => {
      if (!err) {
        this.props.onSubmit && this.props.onSubmit(values)
      }
    })
  }

  /**
   * componentDidMount
   */
  componentDidMount() {
    this.mounted = true
    if (this.props.defaultValues){
      const defaultValues = this.props.defaultValues
      const values = {
        ...buildFormObject(defaultValues),
        iTipoContrib: defaultValues.iTipoContrib ? '1' : '0',
        iProvNacional: defaultValues.iProvNacional ? '1' : '0',
      }
      this.props.form.setFieldsValue(values)
    }
  }

  /**
   * componentWillReceiveProps
   *
   * @param {Object} props
   */
  componentWillReceiveProps(props) {
    if (this.props.defaultValues !== props.defaultValues && this.mounted) {
      const values = {
        ...buildFormObject(props.defaultValues),
        iTipoContrib: props.defaultValues.iTipoContrib ? '1' : '0',
        iProvNacional: props.defaultValues.iProvNacional ? '1' : '0',
      }
      this.props.form.setFieldsValue(values)
    }
  }

  /**
   * componentWillUnmount
   *
   */
  componentWillUnmount() {
    this.mounted = false
  }

  /**
   * render
   *
   */
  render() {
    const { getFieldDecorator, getFieldValue } = this.props.form
    const proveedorNacional = (getFieldValue('iProvNacional') * 1) === 1

    return (
      <Form onSubmit={this.handleSubmit}>
        <Row gutter={16}>
          <Col span={12}>
            <Form.Item label='NACIONAL'>
              {getFieldDecorator('iProvNacional')(
                <Select
                  children={[
                    <Select.Option key='1'>NACIONAL</Select.Option>,
                    <Select.Option key='0'>EXTRANJERO</Select.Option>
                  ]}
                />
              )}
            </Form.Item>
          </Col>
          <Col span={12} style={{ display: proveedorNacional ? 'block' : 'none' }}>
            <Form.Item label='CONTRIBUIDOR'>
              {getFieldDecorator('iTipoContrib')(
                <Select
                  children={[
                    <Select.Option key='1'>PERSONA FÍSICA</Select.Option>,
                    <Select.Option key='0'>PERSONA MORAL</Select.Option>
                  ]}
                />
              )}
            </Form.Item>
          </Col>
        </Row>

        <Row gutter={16}>
          <Col span={10}>
            <Form.Item label={proveedorNacional ? 'RFC' : 'TAX ID'}>
              {getFieldDecorator('sRfc', { rules: [{ required: true, message: 'Requerido' }] })(
                <Input placeholder='RFC' />
              )}
            </Form.Item>
          </Col>

          <Col span={14}>
            <Form.Item label='NOMBRE CORTO'>
              {getFieldDecorator('sNombreCorto', { rules: [{ required: true, message: 'Requerido' }] })(
                <Input placeholder='Nombre corto' />
              )}
            </Form.Item>
          </Col>
        </Row>

        <Row>
          <Col span={24}>
            <Form.Item label='RAZÓN SOCIAL'>
              {getFieldDecorator('sRazonSocial', { rules: [{ required: true, message: 'Requerido' }] })(
                <Input placeholder='Razon Social' />
              )}
            </Form.Item>
          </Col>
        </Row>

        <Row gutter={16}>
          <Col span={12}>
            <Form.Item label='CIUDAD'>
              {getFieldDecorator('sCiudad')(
                <Input placeholder='Ciudad' />
              )}
            </Form.Item>
          </Col>

          <Col span={12}>
            <Form.Item label='ESTADO'>
              {getFieldDecorator('sEstado')(
                <Input placeholder='Estado' />
              )}
            </Form.Item>
          </Col>
        </Row>

        <Row gutter={16}>
          <Col span={18}>
            <Form.Item label='DOMICILIO'>
              {getFieldDecorator('sDomicilio', { rules: [{ required: true, message: 'Requerido' }] })(
                <Input placeholder='Domiclio' multiple={true} />
              )}
            </Form.Item>
          </Col>

          <Col span={6}>
            <Form.Item label='CP'>
              {getFieldDecorator('sCP', { rules: [{ required: true, message: 'Requerido' }] })(
                <Input placeholder='Código postal' />
              )}
            </Form.Item>
          </Col>
        </Row>

        <Row gutter={16}>
          <Col span={12}>
            <Form.Item label='TELÉFONO'>
              {getFieldDecorator('sTelefono')(
                <Input placeholder='Telefono' />
              )}
            </Form.Item>
          </Col>

          <Col span={12}>
            <Form.Item label='EMAIL'>
              {getFieldDecorator('sEmail')(
                <Input placeholder='e-mail' />
              )}
            </Form.Item>
          </Col>
        </Row>

        {this.props.readOnly ?
          null :
          <Row>
            <Form.Item>
              <Popconfirm title='Guardar cambios' onConfirm={() => !this.props.loading ? this.handleSubmit() : undefined}>
                <Button
                  type='primary'
                  loading={this.props.loading}
                  children='GUARDAR'
                />
              </Popconfirm>
            </Form.Item>
          </Row>
        }
      </Form>
    )
  }
}

const WrappedInformacionForm = Form.create({ name: 'informacion' })(InformacionForm)

class InformacionFormModal extends React.Component {
  /**
   * constructor
   *
   */
  constructor(props) {
    super(props)

    this.state = {
      loading: false,
      visible: false,
      data: buildFormObject(),
      monedas: [],
      bancos: [],
    }

    this.formRef = React.createRef()
  }

  /**
   * load
   *
   */
  load = () => {
    this.setState({
      loading: false,
      data: buildFormObject(),
    })

    Api.query({
      __returnType: 'one',
      model: 'ComProveedor',
      attributes: Object.keys(buildFormObject()),
      where: {
        iId: Api.getProviderId(),
      }
    })
    .then(response => {
      this.setState({
        visible: true,
        data: response.data || buildFormObject(),
      })
    })
    .catch(error => {
      this.setState({ loading: false })
      Exception.load(error).show()
    })
  }

  /**
   * onSave
   *
   */
  onSave = (data) => {
    if (this.state.loading) {
      return
    }

    if (!data.errors) {
      this.setState({ loading: true })

      Api.put(`/com/proveedores/${this.state.data.iId}`, data)
        .then(() => {
          this.setState({ visible: false, loading: false })
          this.props.onSaved && this.props.onSaved()
        })
        .catch(error => {
          this.setState({ loading: false })
          Exception.load(error).show()
        })
    }
  }

  /**
   * Render
   *
   */
  render() {
    return (
      <Modal
        title='Editar Información'
        visible={this.state.visible}
        style={{ width: '50%', maxWidth: 520 }}
        onCancel={() => this.setState({ visible: false })}
        footer={false}
        children={
          <WrappedInformacionForm
            onSubmit={this.onSave}
            defaultValues={this.state.data}
            loading={this.state.loading}
            readOnly={this.props.readOnly}
          />
        }
      />
    )
  }
}

export default InformacionFormModal
